// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module__title___26GMi","pc":"Title-module__pc___2T9ET"};